/**
 * Utility helper to export JSON data to Excel-compatible CSV.
 * Uses UTF-8 BOM (\uFEFF) and sep=; directive to ensure perfect rendering of Turkish characters
 * and automatic column separation in all Excel versions.
 * 
 * @param {Array<Object>} data The array of data objects to export.
 * @param {Array<{label: string, key: string}>} headers Array of header mappings containing label and key.
 * @param {string} fileName Name of the exported file (without extension).
 */
export const exportToExcel = (data, headers, fileName) => {
  if (!data || data.length === 0) {
    return;
  }

  // UTF-8 BOM
  let csvContent = '\uFEFF';
  
  // Headers row
  const headerLabels = headers.map(h => `"${h.label.replace(/"/g, '""')}"`);
  csvContent += headerLabels.join(';') + '\r\n';
  
  // Data rows
  data.forEach(row => {
    const rowValues = headers.map(h => {
      let val = row[h.key];
      if (val === undefined || val === null) {
        val = '';
      } else {
        val = String(val);
      }
      return `"${val.replace(/"/g, '""')}"`;
    });
    csvContent += rowValues.join(';') + '\r\n';
  });
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
